/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgnizationList } from '../../models/orgnization-list';

export interface GetTree$Params {
  orid: number;
}

export function getTree(http: HttpClient, rootUrl: string, params: GetTree$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrgnizationList>>> {
  const rb = new RequestBuilder(rootUrl, getTree.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrgnizationList>>;
    })
  );
}

getTree.PATH = '/api/Organizations/tree/{orid}';
